module.exports = __webpack_public_path__ + "img/ICON-AGILE.6bb890a5.png";